import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { FilterComponent } from './filter.component';
import { IconsModule } from 'src/app/icons/icons.module';

@NgModule({
	declarations: [
		FilterComponent
	],
	imports: [
		CommonModule,
		SharedModule,
		IconsModule
	],
	exports: [
		FilterComponent,
	]
})
export class FilterModule { }
